import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import moment from "moment";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { setService } from "../../../../services";

const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/MM/yyyy");

const bookingTypeOption = [
    { value: ["consignment", "loan"], label: "All" },
    { value: ["loan"], label: "Loan" },
    { value: ["consignment"], label: "Consignment" },
];

const firstDayOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  );
  
  const lastDayOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    0
  );

const Sidebar = ({ filterCreateDate,
    kits, selectedKitProp,
    handleFilterRefreesh,
    selectedFilterOperationToDate, selectedFilterOperationFromDate,
    hospitals, selectedHospitalProp,
    repsUsers,selectedRepsUserProp,
    selectedBookingTypeProp
}) => {

    const [createDate, setCreateDate] = useState("");
    const [selectedKit, setSelectedKit] = useState([]);
    const [selectedKitForSets, setSelectedKitForSets] = useState("");

    const [sets, setSetsList] = useState([]);
    const [selectedSet, setSelectedSet] = useState([]);

    // const [filterOperationToDate, setfilterOperationToDate] = useState(new Date());
    // const [filterOperationFromDate, setfilterOperationFromDate] = useState(new Date());
    // const [searchOperationToDate, setSearchOperationToDate] = useState(new Date());
    // const [searchOperationFromDate, setSearchOperationFromDate] = useState(new Date());

    const [filterOperationFromDate, setfilterOperationFromDate] = useState(firstDayOfMonth);
    const [filterOperationToDate, setfilterOperationToDate] = useState(lastDayOfMonth);

    const [searchOperationFromDate, setSearchOperationFromDate] = useState(firstDayOfMonth);
    const [searchOperationToDate, setSearchOperationToDate] = useState(lastDayOfMonth);

    const [selectedHospital, setSelectedHospital] = useState([{ label: "All Hospital", value: "" }]);
    const [hospitalId, setHospitalId] = useState("");
    
    // Select Reps
    const [selectedRepsUser, setSelectedRepsUser] = useState([{ label: "All Reps", value: "" }]);
    const [repsUserId, setRepsUserId] = useState("");

    const [selectedBookingType, setSelectedBookingType] = useState([{ value: ["consignment", "loan"], label: "All" }]);

    const [createDateZIndex, setCreateDateZIndex] = useState(4);
    const [operationZIndex, setOperationZIndex] = useState(6);

    const handleFilter = () => {
        let selectdKitValue = "";
        let selectdSetValue = "";

        selectedKit?.length && selectedKit.map((task) => {
            if (selectdKitValue != "") {
                selectdKitValue += ",";
            }
            selectdKitValue += task.value;
        });

        selectedSet?.length && selectedSet.map((set) => {
            if (selectdSetValue != "") {
                selectdSetValue += ",";
            }
            selectdSetValue += set.value;
        });

        handleFilterRefreesh({
            filterCreateDate: createDate != "" ? moment(createDate).format("YYYY-MM-DD") : "",
            selectdKitValue: selectdKitValue,
            selectedKitProp: selectedKit,
            selectdSetValue: selectdSetValue,
            sideBarFilterOperationToDate: filterOperationToDate,
            sideBarFilterOperationFromDate: filterOperationFromDate,
            selectedHospitalProp: selectedHospital,
            hospitalId: hospitalId,
            selectedRepsUserProp: selectedRepsUser,
            repsUserId: repsUserId,
            bookingType: selectedBookingType[0]?.value,
            selectedBookingTypeProp: selectedBookingType
        });
    };

    const handleCreateDate = (val) => {
        setCreateDate(val != null ? new Date(val) : "");
    };

    const handleFilterClear = () => {
        // const today = new Date();
        setCreateDate("");
        setSelectedHospital([{ label: "All Hospital", value: "" }]);
        setSelectedRepsUser([{ label: "All Reps", value: "" }]);
        setSelectedBookingType([{ value: ["consignment", "loan"], label: "All" }]);
        setSelectedKit([]);
        setSelectedSet([]);
        setSetsList([]);

        // UI state (Date object)
        // setSearchOperationFromDate(today);
        // setSearchOperationToDate(today);
        setSearchOperationFromDate(firstDayOfMonth);
        setSearchOperationToDate(lastDayOfMonth);

        // API state (string format)
        // setfilterOperationFromDate(moment(today).format("YYYY-MM-DD"));
        // setfilterOperationToDate(moment(today).format("YYYY-MM-DD"));
        setfilterOperationFromDate(firstDayOfMonth);
        setfilterOperationToDate(lastDayOfMonth);

        setHospitalId("");
        setRepsUserId("");
        handleFilterRefreesh({
            filterCreateDate: "",
            selectdKitValue: "", selectedKitProp: [],
            selectdSetValue: "",
            // sideBarFilterOperationFromDate: moment(today).format("YYYY-MM-DD"),
            // sideBarFilterOperationToDate: moment(today).format("YYYY-MM-DD"),
            sideBarFilterOperationFromDate: firstDayOfMonth,
            sideBarFilterOperationToDate: lastDayOfMonth,
            hospitalId: "", selectedHospitalProp: [{ label: "All Hospital", value: "" }],
            repsUserId: "", selectedRepsUserProp: [{ label: "All Reps", value: "" }],
            bookingType: ["consignment", "loan"], selectedBookingTypeProp: [{ value: ["consignment", "loan"], label: "All" }],
        });
    };

    useEffect(() => {
        setCreateDate(filterCreateDate != "" ? new Date(filterCreateDate) : "");
        setSelectedKit(selectedKitProp);
        setSearchOperationToDate(selectedFilterOperationToDate);
        setSearchOperationFromDate(selectedFilterOperationFromDate);
        setSelectedHospital(selectedHospitalProp);
        setSelectedBookingType(selectedBookingTypeProp);
        setSelectedRepsUser(selectedRepsUserProp);
    }, []);

    const setSelectedOptionKit = (selectedOptionKit) => {

        let selectdKitValue = "";

        selectedOptionKit?.length && selectedOptionKit.map((task) => {
            if (selectdKitValue != "") {
                selectdKitValue += ",";
            }
            selectdKitValue += task.value;
        });

        setSelectedKit(selectedOptionKit);
        setSetsList([]);
        setSelectedSet([]);

        setSelectedKitForSets(selectdKitValue);


    };

    useEffect(() => {
        if (selectedKitForSets !== "" && selectedKit?.length) {
            getSetsUsingKitIdForBookingFilter();
        }
    }, [selectedKitForSets]);

    const setSelectedOptionSet = (selectedOptionSet) => {
        setSelectedSet(selectedOptionSet);
    };

    const getSetsUsingKitIdForBookingFilter = async () => {
        try {

            const res = await setService.getSetsUsingKitIdForBookingFilter({ kitId: selectedKitForSets });

            let setsList = res?.data ? res?.data : [];
            let tempSetsList = [];
            setsList && setsList.map(item => {
                let option = { value: item._id, label: item.set_name, id: item._id, kitID: item.kitID };
                tempSetsList.push(option);
            });
            setSetsList(tempSetsList);

        } catch (error) {
            console.error("Error: ", error);
        }
    };

    const handleSearchOperationFromDate = (val) => {
        setSearchOperationFromDate(val != null ? new Date(val) : "");
        setfilterOperationFromDate(val != null ? moment(val).format("YYYY-MM-DD") : "");
    };

    const handleSearchOperationToDate = (val) => {
        setSearchOperationToDate(val != null ? new Date(val) : "");
        setfilterOperationToDate(val != null ? moment(val).format("YYYY-MM-DD") : "");
    };

    const setSelectedOptionHospital = (e) => {
        let selectedHospitalValue = [{ value: e.value, label: e.label }];
        setHospitalId(e.value);
        setSelectedHospital(selectedHospitalValue);
    };

    const setSelectedOptionRepsUser = (e) => {
        let selectedRepsUserValue = [{ value: e.value, label: e.label }];
        setRepsUserId(e.value);
        setSelectedRepsUser(selectedRepsUserValue);
    };

    const setSelectedOptionBookingType = (e) => {
        var selectedBookingTypeValue = [{ value: e.value, label: e.label }];
        setSelectedBookingType(selectedBookingTypeValue);
    };

    return (
        <div className="" >

            <div className="card-body">

                <div className="row no-gutters">


                    <label className="form-label">Operation Date</label>
                    <div className="row position_up" style={{ zIndex: operationZIndex }}>
                        <div className="col-12 mb-2">
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                showClearButton={false}
                                placeholderText="Operation From"
                                selected={searchOperationFromDate}
                                onChange={(e) => handleSearchOperationFromDate(e)}
                                onFocus={()=> setOperationZIndex(20)}
                                onCalendarClose={()=> setOperationZIndex(6)}
                                className="form-control"
                                customInput={
                                    <MaskedInput
                                        pipe={autoCorrectedDatePipe}
                                        mask={[
                                            /\d/,
                                            /\d/,
                                            "/",
                                            /\d/,
                                            /\d/,
                                            "/",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        keepCharPositions={true}
                                        guide={true}
                                        showMask={false}
                                    />
                                }
                            />
                        </div>

                        <div className="col-12 mb-2">
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                showClearButton={false}
                                placeholderText="Collection To"
                                selected={searchOperationToDate}
                                onChange={(e) => handleSearchOperationToDate(e)}
                                onFocus={()=> setOperationZIndex(20)}
                                onCalendarClose={()=> setOperationZIndex(6)}
                                className="form-control"
                                customInput={
                                    <MaskedInput
                                        pipe={autoCorrectedDatePipe}
                                        mask={[
                                            /\d/,
                                            /\d/,
                                            "/",
                                            /\d/,
                                            /\d/,
                                            "/",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        keepCharPositions={true}
                                        guide={true}
                                        showMask={false}
                                    />
                                }
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-3 text-left position_up"
                            style={{ zIndex: 11 }}>
                            <label className="form-label">Booking Type</label>
                            <Select
                                className="text-left"
                                value={
                                    selectedBookingType
                                }
                                onChange={setSelectedOptionBookingType}
                                options={bookingTypeOption}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4 text-left position_up" style={{ zIndex: 10 }}>
                            <label className="form-label">Hospital Name</label>
                            <Select
                                value={selectedHospital}
                                onChange={(e) => setSelectedOptionHospital(e)}
                                options={hospitals}

                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-4 text-left position_up" style={{ zIndex: 11, display:"none" }}>
                            <label className="form-label">Reps Name</label>
                            <Select
                                value={selectedRepsUser}
                                onChange={(e) => setSelectedOptionRepsUser(e)}
                                options={repsUsers}

                            />
                        </div>
                    </div>

                    <div className="col-12" style={{ zIndex: 9 }}>
                        <div className="mb-3 text-left react-multiselect-checkbox" >
                            <label className="form-label">Kits List</label>
                            <ReactMultiSelectCheckboxes
                                placeholderButtonLabel="All Kits"
                                value={selectedKit}
                                onChange={setSelectedOptionKit}
                                className={""}
                                options={kits}
                                placeholder="All Kits"
                            />
                        </div>
                    </div>

                    <div className="col-12" style={{ zIndex: 8 }}>
                        <div className="mb-3 text-left react-multiselect-checkbox" >
                            <label className="form-label">Sets List</label>
                            <ReactMultiSelectCheckboxes
                                placeholderButtonLabel="Sets List"
                                value={selectedSet}
                                onChange={setSelectedOptionSet}
                                className={""}
                                options={sets}
                                placeholder="Sets List"
                            />
                        </div>
                    </div>




                    <div className="col-12" style={{display:"none"}}>
                        <div className="mb-3 text-left position_up" style={{ zIndex: createDateZIndex }}>
                            <label className="form-label">Create Date</label>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                showClearButton={false}
                                placeholderText="Select Date"
                                selected={createDate}
                                onChange={e =>
                                    handleCreateDate(
                                        e,
                                    )
                                }
                                onFocus={()=> setCreateDateZIndex(21)}
                                onCalendarClose={()=> setCreateDateZIndex(4)}
                                className="form-control"
                                customInput={
                                    <MaskedInput
                                        pipe={autoCorrectedDatePipe}
                                        mask={[
                                            /\d/,
                                            /\d/,
                                            "/",
                                            /\d/,
                                            /\d/,
                                            "/",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        keepCharPositions={true}
                                        guide={true}
                                        showMask={false}
                                    />
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-footer text-right">
                <a className="mr-3" onClick={() => handleFilterClear()} href="javascript:;">
                    <span>Clear Filters</span>
                </a>
                <a onClick={() => handleFilter()} className="btn btn-sm btn-primary">Apply</a>
            </div>

        </div>
    );
};
export default Sidebar;

